import type { WorkflowState } from './state';

export function setApplication(
  state: WorkflowState,
  action: { payload: WorkflowState['application'] },
) {
  state.application = action.payload;
}
